import { EClientPath, EMarketingClientPath } from '~/models/api'

type TPageMetadata = {
  title: string
  description: string
}
const getPageMetadata = (
  routePath: EClientPath | EMarketingClientPath,
  partnerName: string,
): TPageMetadata => {
  if (!partnerName) {
    return {
      title: 'heyLibby',
      description: 'HeyLibby - Connect with your leads',
    }
  }

  const partialTextChunk = [partnerName]

  switch (routePath) {
    case EMarketingClientPath.home:
      partialTextChunk.push('AI Receptionist')
      break
    case EMarketingClientPath.examplePage:
      partialTextChunk.push('See an example')
      break
    case EClientPath.onboardingBasicInfo:
    case EClientPath.demoBasicInfo:
    case EClientPath.onboardingCreatingLibby:
    case EClientPath.demoCreatingLibby:
    case EClientPath.onboardingTryItOut:
    case EClientPath.demoTryItOut:
      partialTextChunk.push('Onboarding')
      break
    case EMarketingClientPath.about:
      partialTextChunk.push('About')
      break
    case EMarketingClientPath.supportAndContact:
      partialTextChunk.push('Support')
      break
    case EMarketingClientPath.pricing:
      partialTextChunk.push('Pricing')
      break
    case EMarketingClientPath.faq:
      partialTextChunk.push('FAQ')
      break
    case EMarketingClientPath.referralsAbout:
      partialTextChunk.push('Referral program')
      break
    case EClientPath.overview:
      partialTextChunk.push('Account Overview')
      break
    case EClientPath.settingsBase:
      partialTextChunk.push('Account Settings')
      break
    case EClientPath.contacts:
      partialTextChunk.push('Account Contacts')
      break
    case EClientPath.reports:
      partialTextChunk.push('Account Reports')
      break
    case EClientPath.billing:
      partialTextChunk.push('Account Billing')
      break
    case EClientPath.referralsInfo:
      partialTextChunk.push('Account Referrals')
      break
    case EClientPath.chat:
    case EClientPath.legacyChat:
      partialTextChunk.push('Chat')
      break
    default:
  }

  return {
    title: partialTextChunk.join(' - '),
    description: partialTextChunk.join(' - '),
  }
}

export default getPageMetadata
